import "./SpinnerCheck.scss";

import { FC } from "react";

export const SPINNER_ANIMATION_DURATION = 5000;

const SpinnerCheck: FC = () => {
  return (
    <div className="spinner-check-container">
      <div className="spinner-check__border">
        <svg
          className="spinner-check__checkmark"
          xmlns="http://www.w3.org/2000/svg"
          width="79"
          height="56"
          viewBox="0 0 79 56"
          fill="none">
          <path
            className="spinner-check__checkmark-path"
            d="M4.47461 26.8491L28.7421 51.0175L74.9658 4.98242"
            pathLength={100}
            stroke="#5C43F5"
            strokeWidth="8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default SpinnerCheck;
